import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { AiKnowledgeConfig, RouteCommand } from './interface/config.interface';
import { Namespace, TargetOption } from './knowledge-management/types';

export const AI_KNOWLEDGE_CONFIG_TOKEN = new InjectionToken<AiKnowledgeConfig>(
  '[AiKnowledge]: token for configuration',
);

export const ACCOUNT_GROUP_ID_TOKEN: InjectionToken<Observable<string>> = new InjectionToken(
  '[AiKnowledge]: token for accountGroupId',
);

export const MARKET_ID_TOKEN: InjectionToken<Observable<string>> = new InjectionToken(
  '[AiKnowledge]: token for marketId',
);

export const PARTNER_ID_TOKEN: InjectionToken<Observable<string>> = new InjectionToken(
  '[AiKnowledge]: token for partnerId',
);

export const MANAGE_KNOWLEDGE_URL_TOKEN: InjectionToken<Observable<string>> = new InjectionToken(
  '[AiKnowledge]: token for manageKnowledgeUrl',
);

export const BUSINESS_PROFILE_URL_TOKEN: InjectionToken<Observable<string>> = new InjectionToken(
  '[AiKnowledge]: token for businessProfileUrl',
);

export const SHOW_BUSINESS_PROFILE_SOURCE_TOKEN: InjectionToken<Observable<boolean>> = new InjectionToken(
  '[AiKnowledge]: token for showBusinessProfileSource',
);

export const WEB_CHAT_WIDGET_EDIT_ROUTE_TOKEN: InjectionToken<Observable<RouteCommand[]>> = new InjectionToken(
  '[AiKnowledge]: token for webChatWidgetEditRoute',
);

export const EDITING_ENABLED_TOKEN: InjectionToken<Observable<boolean>> = new InjectionToken(
  '[AiKnowledge]: token for editingEnabled',
);

// ─── Knowledge-sharing tokens ──────────────────────────────────

export const KNOWLEDGE_GRANTS_ENABLED_TOKEN: InjectionToken<Observable<boolean>> = new InjectionToken(
  '[AiKnowledge]: token for knowledgeGrantsEnabled',
);

export const CAN_SHARE_WITH_PARTNERS_TOKEN: InjectionToken<Observable<boolean>> = new InjectionToken(
  '[AiKnowledge]: token for canShareWithPartners',
);

export const CAN_SHARE_WITH_ACCOUNT_GROUPS_TOKEN: InjectionToken<Observable<boolean>> = new InjectionToken(
  '[AiKnowledge]: token for canShareWithAccountGroups',
);

// Derived: whether any share affordance is available at all (drives the per-row "Share…" button). True when either capability is granted.
export const CAN_SHARE_TOKEN: InjectionToken<Observable<boolean>> = new InjectionToken(
  '[AiKnowledge]: token for canShare (canShareWithAccountGroups || canShareWithPartners)',
);

export type PartnerNameResolver = (namespace: Namespace) => Observable<string>;
export const PARTNER_NAME_RESOLVER_TOKEN: InjectionToken<PartnerNameResolver> = new InjectionToken(
  '[AiKnowledge]: token for partnerNameResolver',
);

export type TargetLookup = (query: string) => Observable<TargetOption[]>;
export const ACCOUNT_GROUPS_LOOKUP_TOKEN: InjectionToken<TargetLookup | null> = new InjectionToken(
  '[AiKnowledge]: token for accountGroupsLookup',
);
export const MULTI_LOCATION_GROUPS_LOOKUP_TOKEN: InjectionToken<TargetLookup | null> = new InjectionToken(
  '[AiKnowledge]: token for multiLocationGroupsLookup',
);
export const PARTNERS_LOOKUP_TOKEN: InjectionToken<TargetLookup | null> = new InjectionToken(
  '[AiKnowledge]: token for partnersLookup',
);
